<template>
  <div>
    <header
      class="relative flex bg-cyan-light uppercase font-bold text-sm p-4 rounded-t-xl z-50"
    >
      Władze spółki
    </header>
    <section class="relative bg-white px-12 pt-8 pb-12 rounded-b-xl z-50">
      <div v-if="item && item.data" class="max-w-5xl m-auto">
        <h4 class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]">
          <span v-if="parseInt(company_type) === 1">Zarząd</span>
          <span v-if="parseInt(company_type) > 1">Wspólnicy</span>
        </h4>
        <div
          v-if="board.length > 0"
          class="border-t border-gray-light mb-4 pt-6"
        >
          <div v-for="(el, key) in board" :key="'board_' + key">
            <div class="flex w-full mb-8 -mx-3 text-xs">
              <div class="w-[4%] px-3 font-bold">{{ key + 1 }}.</div>
              <div class="w-[16%] px-3">
                <div class="flex break-all font-bold">
                  {{ board[key].first_name }}
                  {{ board[key].last_name }}
                </div>
              </div>
              <div class="w-[18%] px-3">
                <div class="flex break-all font-bold">
                  {{ board[key].phone }}
                </div>
              </div>
              <div class="w-[20%] px-3 font-bold">
                {{ board[key].email }}
              </div>
              <div class="w-[30%] px-3">
                <div class="flex break-all font-bold">
                  {{ board[key].position }}
                </div>
              </div>
              <div class="w-[12%] px-3">
                <div class="flex gap-3 justify-center font-bold text-violet">
                  <span
                    @click.stop.prevent="editBoardMember(key)"
                    class="cursor-pointer"
                  >
                    Edytuj
                  </span>
                  <span
                    v-if="board.length > 1"
                    @click.stop.prevent="removeBoardMember(key)"
                    class="cursor-pointer"
                  >
                    Usuń
                  </span>
                </div>
              </div>
            </div>
            <hr class="pt-6" />
          </div>
        </div>
        <div class="flex mb-8">
          <button
            v-if="!boardForm"
            class="flex items-center gap-2 bg-violet rounded-3xl py-2 pl-5 pr-3 text-white focus:outline-none"
            @click.stop.prevent="boardForm = true"
          >
            <span class="text-sm font-bold"> Dodaj osobę </span>
            <svg
              width="17"
              height="17"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10" cy="10" r="10" fill="white" />
              <path
                d="M10 6.25V13.75"
                stroke="#591144"
                stroke-linecap="round"
              />
              <path
                d="M13.75 10L6.25 10"
                stroke="#591144"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <form
          v-show="boardForm"
          id="partnerBoardSingleForm"
          method="POST"
          :action="'/me'"
        >
          <div class="flex flex-wrap lg:flex-nowrap w-full mb-4 lg:mb-8 -mx-3">
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">Imię</label>
                <input
                  type="text"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][first_name]'"
                  required
                  v-model="z.first_name"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">Nazwisko</label>
                <input
                  type="text"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][last_name]'"
                  required
                  v-model="z.last_name"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-2/12 mt-4 lg:mt-0 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">Telefon</label>
                <input
                  type="text"
                  class="phone border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][phone]'"
                  @keydown="keyDown"
                  required
                  v-model="z.phone"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-4/12 mt-4 lg:mt-0 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">E-mail</label>
                <input
                  type="email"
                  class="email border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][email]'"
                  required
                  v-model="z.email"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap lg:flex-nowrap w-full mb-8 -mx-3">
            <div
              class="w-1/2 lg:w-1/4 px-3"
              v-if="parseInt(company_type) === 1"
            >
              <div class="flex flex-col mb-4 lg:mb-0">
                <label class="text-dark text-xs font-bold mb-1"
                  >Stanowisko</label
                >
                <select-field
                  :name="boardName + '[][position]'"
                  class="tw-select2-override"
                  placeholder="Wybierz"
                  :options="{ values: dictionary.boardPositions }"
                  v-model="z.position"
                  required
                  :selected="z.position"
                ></select-field>
              </div>
            </div>
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">KRK</label>
                <select-field
                  :name="boardName + '[][krk]'"
                  class="tw-select2-override"
                  placeholder="Wybierz"
                  :options="{ values: dictionary.krkOptions }"
                  v-model="z.krk"
                  required
                  :selected="z.krk"
                ></select-field>
              </div>
            </div>
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">PESEL</label>
                <input
                  type="text"
                  class="pesel tracking-wider border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][pesel]'"
                  required
                  v-model="z.pesel"
                />
              </div>
            </div>
            <div
              class="w-1/2 lg:w-1/4 mt-4 lg:mt-0 px-3"
              v-if="parseInt(company_type) === 3"
            >
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">NIP</label>
                <input
                  type="text"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="boardName + '[][nip]'"
                  required
                  v-model="z.nip"
                />
              </div>
            </div>
            <div
              class="w-1/2 lg:w-1/4 mt-4 lg:mt-0 px-3"
              v-if="parseInt(company_type) === 3"
            >
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1"
                  >Dane działalności</label
                >
                {{ z.name }}
                <div>
                  {{ z.street }}
                  {{ z.number }}
                  <span v-if="z.flat && z.flat.length > 0"
                    >lok. {{ z.flat }}</span
                  >
                </div>
                <div>
                  {{ z.postal }}
                  {{ z.city }}
                </div>
                <input
                  type="hidden"
                  :name="boardName + '[][name]'"
                  v-model="z.name"
                />
                <input
                  type="hidden"
                  :name="boardName + '[][street]'"
                  v-model="z.street"
                />
                <input
                  type="hidden"
                  :name="boardName + '[][number]'"
                  v-model="z.number"
                />
                <input
                  type="hidden"
                  :name="boardName + '[][flat]'"
                  v-model="z.flat"
                />
                <input
                  type="hidden"
                  :name="boardName + '[][postal]'"
                  v-model="z.postal"
                />
                <input
                  type="hidden"
                  :name="boardName + '[][city]'"
                  v-model="z.city"
                />
              </div>
            </div>
          </div>

          <div class="flex justify-end">
            <button
              v-if="board && board.length > 0"
              class="flex items-center gap-2 border border-violet rounded-3xl py-2 pl-5 pr-4 text-violet focus:outline-none mr-2"
              @click.stop.prevent="hideBoardForm"
            >
              <span class="text-sm font-bold">Anuluj</span>
            </button>
            <button
              class="flex items-center gap-2 bg-violet rounded-3xl py-2 pl-5 pr-4 text-white focus:outline-none"
              type="submit"
            >
              <span class="text-sm font-bold">Zapisz</span>
            </button>
          </div>
        </form>
        <hr class="my-10" />
        <h4 class="uppercase text-violet font-bold text-sm mb-8 min-h-[25px]">
          Reprezentanci
          <span class="text-sm font-normal normal-case"
            >- Podpisujący w imieniu spółki umowę z ANG</span
          >
        </h4>
        <div
          v-if="reps.length > 0"
          class="border-t border-gray-light mb-4 pt-6"
        >
          <div v-for="(el, key) in reps" :key="'reps_' + key">
            <div class="flex w-full mb-8 -mx-3 text-xs">
              <div class="w-[4%] px-3 font-bold">{{ key + 1 }}.</div>
              <div class="w-[16%] px-3">
                <div class="flex break-all font-bold">
                  {{ reps[key].first_name }}
                  {{ reps[key].last_name }}
                </div>
              </div>
              <div class="w-[18%] px-3">
                <div class="flex break-all font-bold">
                  {{ reps[key].phone }}
                </div>
              </div>
              <div class="w-[20%] px-3 break-words font-bold">
                {{ reps[key].email }}
              </div>
              <div class="w-[30%] px-3">
                <div class="flex break-words font-bold">
                  {{ reps[key].position }}
                </div>
              </div>
              <div class="w-[12%] px-3">
                <div class="flex gap-3 justify-center font-bold text-violet">
                  <span
                    @click.stop.prevent="editRepresentationMember(key)"
                    class="cursor-pointer"
                  >
                    Edytuj
                  </span>
                  <span
                    v-if="reps.length > 1"
                    @click.stop.prevent="removeRepresentationMember(key)"
                    class="cursor-pointer"
                  >
                    Usuń
                  </span>
                </div>
              </div>
            </div>
            <hr class="pt-6" />
          </div>
        </div>
        <div class="flex mb-8">
          <button
            v-if="!repsForm"
            class="flex items-center gap-2 bg-violet rounded-3xl py-2 pl-5 pr-3 text-white focus:outline-none"
            @click.stop.prevent="repsForm = true"
          >
            <span class="text-sm font-bold"> Dodaj osobę</span>
            <svg
              width="17"
              height="17"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10" cy="10" r="10" fill="white" />
              <path
                d="M10 6.25V13.75"
                stroke="#591144"
                stroke-linecap="round"
              />
              <path
                d="M13.75 10L6.25 10"
                stroke="#591144"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <form
          v-show="repsForm"
          id="partnerRepSingleForm"
          method="POST"
          :action="'/me'"
        >
          <div class="flex flex-wrap lg:flex-nowrap w-full mb-4 lg:mb-8 -mx-3">
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1"> Imię </label>
                <input
                  type="text"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="repsName + '[][first_name]'"
                  required
                  v-model="rep.first_name"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">Nazwisko</label>
                <input
                  type="text"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="repsName + '[][last_name]'"
                  required
                  v-model="rep.last_name"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-2/12 mt-4 lg:mt-0 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">Telefon</label>
                <input
                  type="text"
                  class="phone border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="repsName + '[][phone]'"
                  @keydown="keyDown"
                  required
                  v-model="rep.phone"
                />
              </div>
            </div>
            <div class="w-1/2 lg:w-4/12 mt-4 lg:mt-0 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1">E-mail</label>
                <input
                  type="email"
                  class="border border-[#591245] rounded-lg text-dark text-xs pl-2 h-10 focus:outline-none"
                  :name="repsName + '[][email]'"
                  required
                  v-model="rep.email"
                />
              </div>
            </div>
          </div>

          <div class="flex w-full mb-8 -mx-3">
            <div class="w-1/2 lg:w-1/4 px-3">
              <div class="flex flex-col">
                <label class="text-dark text-xs font-bold mb-1"
                  >Stanowisko</label
                >
                <select-field
                  :name="repsName + '[][position]'"
                  placeholder="Wybierz"
                  class="tw-select2-override"
                  required
                  :options="{
                    values: dictionary.representationPositions,
                  }"
                  v-model="rep.position"
                  :selected="rep.position"
                >
                </select-field>
              </div>
            </div>
          </div>
          <div class="flex justify-end">
            <button
              v-if="reps && reps.length > 0"
              class="flex items-center gap-2 border border-violet rounded-3xl py-2 pl-5 pr-4 text-violet focus:outline-none mr-2"
              @click.stop.prevent="hideRepsForm"
            >
              <span class="text-sm font-bold">Anuluj</span>
            </button>
            <button
              type="submit"
              class="flex items-center gap-2 bg-violet rounded-3xl py-2 pl-5 pr-4 text-white focus:outline-none"
            >
              <span class="text-sm font-bold">Zapisz</span>
            </button>
          </div>
        </form>
        <hr class="my-10" />
        <form
          v-show="!loading"
          id="partnerPeopleForm"
          class="recruitmentForm"
          method="POST"
          :action="action"
        >
          <div class="mb-5">
            <div class="flex relative text-justify pr-6 form-check-after">
              <div v-for="(el, key) in reps" :key="'reps_hidden_' + key">
                <input
                  type="hidden"
                  :name="repsName + '[' + key + '][first_name]'"
                  v-model="reps[key].first_name"
                />
                <input
                  type="hidden"
                  :name="repsName + '[' + key + '][position]'"
                  v-model="reps[key].position"
                />
                <input
                  type="hidden"
                  :name="repsName + '[' + key + '][email]'"
                  v-model="reps[key].email"
                />
                <input
                  type="hidden"
                  :name="repsName + '[' + key + '][phone]'"
                  v-model="reps[key].phone"
                />
                <input
                  type="hidden"
                  :name="repsName + '[' + key + '][last_name]'"
                  v-model="reps[key].last_name"
                />
              </div>
              <div v-for="(el, key) in board" :key="'board_hidden_' + key">
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][first_name]'"
                  v-model="board[key].first_name"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][position]'"
                  v-model="board[key].position"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][email]'"
                  v-model="board[key].email"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][last_name]'"
                  v-model="board[key].last_name"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][phone]'"
                  v-model="board[key].phone"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][pesel]'"
                  v-model="board[key].pesel"
                />
                <input
                  type="hidden"
                  :name="boardName + '[' + key + '][krk]'"
                  v-model="board[key].krk"
                />
              </div>
              <slot></slot>
            </div>
          </div>
          <p class="text-sm text-justify pl-8 pr-6">
            Podstawę do pobierania informacji z KRK stanowi art. 6 ust. 1 pkt 10
            ustawy z dnia 24 maja 2000 r. o Krajowym Rejestrze Karnym (t.j. Dz.
            U. 2021 poz. 1709) w zw. z art. 54 ust. 4 pkt 1 lit. b) oraz art. 54
            ust. 4 pkt 2 i 3 ustawy z dnia 23 marca 2017 r. o kredycie
            hipotecznym oraz o nadzorze nad pośrednikami kredytu hipotecznego i
            agentami (Dz. U. 2017 poz. 819 ze zm.) lub w zw. z art. 59da ust. 2
            ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim (Dz. U. 2011
            Nr 126 poz. 715 ze zm.) lub w zw. z art. 19 ust. 1 pkt 2 ustawy z
            dnia 15 grudnia 2017 r. o dystrybucji ubezpieczeń (Dz. U. 2017 poz.
            2486 ze zm.).
          </p>
          <div
            class="relative mt-3 bg-[#ffe6e6] p-5 mt-6 rounded-lg border border-red z-50"
            v-if="error"
          >
            <h5 class="text-red font-bold">Wystąpił błąd!</h5>
            <label class="text-red mt-3 error">{{ error }} </label>
          </div>
        </form>
      </div>
    </section>
    <template>
      <div v-if="loading || sending" class="flex justify-center my-3">
        <spinner position="ml-auto" :grid="true"></spinner>
      </div>
      <div v-else class="flex justify-between mt-8">
        <template>
          <div
            class="flex items-center bg-transparent border border-violet border-solid rounded-3xl py-3 px-12 font-bold text-violet cursor-pointer z-50 focus:outline-none"
            @click="$emit('back')"
          >
            Wstecz
          </div>
          <div
            class="flex items-center bg-pink border border-pink border-solid rounded-3xl py-3 px-12 font-bold text-white z-50 focus:outline-none cursor-pointer"
            @click.prevent.stop="checkPhonesAndEmails('#partnerPeopleForm')"
          >
            Dalej5
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import spinner from "@/components/partials/misc/spinner";
import recruitment from "@/mixins/recruitment";
import select from "@/components/partials/misc/selectHR";
import ajax from "@/services/ajax";
import $ from "jquery";
import tippy from "tippy.js";
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      rep_key: null,
      rep: {},
      z_key: null,
      z: {},
      boardForm: false,
      repsForm: false,
      expanded: {
        company_team: false,
        company_board: false,
        company: false,
      },
    };
  },
  components: {
    spinner,
    "select-field": select,
  },
  watch: {
    step() {
      this.tip();
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      ajax.justValidate($("#partnerBoardSingleForm"), function () {
        self.addBoardMember();
      });
      ajax.justValidate($("#partnerRepSingleForm"), function () {
        self.addRepresentationMember();
      });
    });
    if (
      (this.step === 3 && this.item.data.step && !this.item.data.step[3]) ||
      (this.step === 21 && this.item.data.step && !this.item.data.step[21])
    ) {
      if (this.reps && this.reps.length === 1) {
        this.rep = this.reps[0];
        this.repsForm = true;
        this.reps.pop();
      }
      if (this.board && this.board.length === 1) {
        this.z = this.board[0];
        this.boardForm = true;
        this.board.pop();
      }
    }
  },
  props: ["shortcut", "boardName", "repsName", "board", "reps", "company_type"],
  mixins: [recruitment],
  name: "companyRepresentationForm",
  methods: {
    hideBoardForm() {
      this.boardForm = false;
      if (this.board && this.board.length > 0) {
        this.z = {
          first_name: "",
          last_name: "",
          phone: "",
          email: "",
          position: "",
          pesel: "",
          krk: "",
        };
      }
    },
    hideRepsForm() {
      this.repsForm = false;

      if (this.reps && this.reps.length > 0) {
        this.rep = {
          first_name: "",
          last_name: "",
          phone: "",
          email: "",
          position: "",
        };
      }
    },

    keyDown: function (e) {
      if (
        [
          8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101,
          102, 103, 104, 105, 37, 39, 109, 9,
        ].indexOf(e.which) === -1
      ) {
        e.preventDefault();
      }
    },
    addRepresentationMember() {
      if (
        !this.rep.first_name ||
        !this.rep.last_name ||
        !this.rep.email ||
        !this.rep.phone ||
        !this.rep.position
      ) {
        return alert("nie podano wszystkich danych");
      }
      if (this.rep_key === null) {
        this.reps.push(this.rep);
      } else {
        this.reps[this.rep_key] = JSON.parse(JSON.stringify(this.rep));
        this.rep_key = null;
      }
      this.rep = {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        position: "",
      };
      this.repsForm = false;
    },
    removeRepresentationMember(key) {
      this.reps.splice(key, 1);
    },
    addBoardMember() {
      if (
        !this.z.first_name ||
        !this.z.last_name ||
        !this.z.email ||
        !this.z.phone ||
        !this.z.position ||
        !this.z.krk ||
        !this.z.pesel
      ) {
        return alert("nie podano wszystkich danych");
      }
      if (this.z_key === null) {
        this.board.push(this.z);
      } else {
        this.board[this.z_key] = JSON.parse(JSON.stringify(this.z));
        this.z_key = null;
      }
      this.z = {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        position: "",
        pesel: "",
        krk: "",
      };
      this.boardForm = false;
    },
    removeBoardMember(key) {
      this.board.splice(key, 1);
    },
    tip() {
      this.$nextTick(() => {
        tippy("[data-tippy-content]");
      });
    },

    checkPhonesAndEmails(form) {
      this.error = null;
      let phones = [];
      let emails = [];
      let pesels = [];

      if (
        this.step === 3 &&
        this.item.data &&
        this.reps.length === 0 &&
        this.board.length === 0 &&
        !this.repsForm &&
        !this.boardForm
      ) {
        alert("Uzupełnij dane Zarządu i Reprezentantów");
        return;
      } else if (this.repsForm || this.boardForm) {
        alert(
          "Najwpierw zakończ (guzik ZAPISZ) edycję danych Zarządu i Reprezentantów"
        );
        return;
      }

      if (this.board) {
        for (let i = 0; i < this.board.length; i++) {
          if (this.board[i].phone && phones.indexOf(this.board[i].phone) >= 0) {
            this.error =
              "Numery telefonów Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          phones.push(this.board[i].phone);
          if (this.board[i].pesel && pesels.indexOf(this.board[i].pesel) >= 0) {
            this.error =
              "Numery PESEL Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          pesels.push(this.board[i].pesel);
          if (this.board[i].email && emails.indexOf(this.board[i].email) >= 0) {
            this.error =
              "Adresy e-mail Członków Zarządu i/lub Wspólników muszą być unikalne";
            return false;
          }
          emails.push(this.board[i].email);
        }
      }

      if (this.reps) {
        phones = [];
        emails = [];
        for (let i = 0; i < this.reps.length; i++) {
          if (this.reps[i].phone && phones.indexOf(this.reps[i].phone) >= 0) {
            this.error = "Numery telefonów Reprezentantów muszą być unikalne";
            return false;
          }
          phones.push(this.reps[i].phone);
        }
        for (let i = 0; i < this.reps.length; i++) {
          if (this.reps[i].email && emails.indexOf(this.reps[i].email) >= 0) {
            this.error = "Adresy e-mail Reprezentantów muszą być unikalne";
            return false;
          }
          emails.push(this.reps[i].email);
        }
      }
      if (this.item.recruits) {
        phones = [];
        emails = [];
        for (let i = 0; i < this.item.recruits.length; i++) {
          if (
            this.item.recruits[i].phone &&
            phones.indexOf(this.item.recruits[i].phone) >= 0
          ) {
            this.error = "Numery telefonów Ekspertów muszą być unikalne";
            return false;
          }
          phones.push(this.item.recruits[i].phone);
        }
        for (let i = 0; i < this.item.recruits.length; i++) {
          if (
            this.item.recruits[i].email &&
            emails.indexOf(this.item.recruits[i].email) >= 0
          ) {
            this.error = "Adresy e-mail Ekspertów muszą być unikalne";
            return false;
          }
          emails.push(this.item.recruits[i].email);
        }
      }

      $(form).submit();
    },
    editBoardMember(key) {
      this.z = JSON.parse(JSON.stringify(this.board[key]));
      this.z_key = key;
      this.boardForm = true;
    },
    editRepresentationMember(key) {
      console.log(key);
      this.rep = JSON.parse(JSON.stringify(this.reps[key]));
      this.rep_key = key;
      this.repsForm = true;
    },

    enter: function (el) {
      Velocity(el, "fadeIn", {
        duration: 500,
        easing: "easeInBack",
      });
    },
    leave: function (el) {
      Velocity(el, "fadeOut", {
        duration: 0,
        easing: "easeInBack",
      });
    },
  },
};
</script>
